// extracted by mini-css-extract-plugin
export default {"meals":"MealList_meals__VAiqn","meals-appear":"MealList_meals-appear__liUgp"};